// ISO 639-1
export const LANGUAGES = {
  ENGLISH: 'en',
  ITALIAN: 'it',
  SPANISH: 'es',
  PORTUGUESE: 'pt',
}